import { Component, Injector, OnInit} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrdemProducao } from 'src/app/models/ind/ordem-producao/ordem-producao';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ConfirmModalComponent } from 'src/app/shared/components/confirm-modal/confirm-modal.component';
import { CustomSnackBarService } from 'src/app/shared/components/custom-snack-bar/custom-snack-bar.service';

@Component({
  selector: 'app-reporte-modal',
  templateUrl: './reporte-modal.component.html',
  styleUrls: ['./reporte-modal.component.scss']
})
export class ReporteModalComponent implements OnInit {

  dialogRef: MatDialogRef<ReporteModalComponent>;
  dialogData: OrdemProducao;

  form: UntypedFormGroup;

  saldoOrdem: number = 0;

  constructor(
    private authService: AuthService,
    private snackBar: CustomSnackBarService,
    private injector: Injector,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog
  ) {
    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
  }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm()
  {

    this.saldoOrdem = this.dialogData.quantidadeProduzir - this.dialogData.quantidadeProduzida;

    this.form = this.formBuilder.group({
      quantidade: [this.saldoOrdem, Validators.compose([Validators.required,
                                                        Validators.min(0),
                                                        Validators.max(this.saldoOrdem)])],
    });
  }

  reportar()
  {
    if (this.form.valid)
    {
      const confirmCancelDataDialog = this.dialog.open(ConfirmModalComponent, {
        data: {
          title: "Confirmar Reporte",
          msg: `Confirma o Reporte?`,
        },
      });
      confirmCancelDataDialog.beforeClosed().subscribe((result) => {
        if(result){
          this.dialogRef.close({quantidade: this.form.controls['quantidade'].value});
        }
      });
    }
  }
}
